const theme = {
  light: {
    fontFamily: {
      regular: "iranSansRegular",
      bold: "iranSansBold",
      extraBold: "iranSansExteraBold",
      light: "iranSansLight",
      medium: "iranSansMedium",
      demiBold: "iranSansDemiBold",
      normal: "IRANSans",
    },
    backgroundColor: {
      bgPrimary: "#FAFAFA",
      bgSecondary: "#ffffff",
      bgTertiary: "#004749",
      bgTertiaryTrans: "#003738f2",
      bgSuccess: "#9EE1D1",         
      bgDanger: "#F44336",         
      bgWarning: "#FF9800",          
      bgInfo: "#2196F3",             
      bgGray: "#E8E8E8",    
      bgForm: "#ffffff",                      
      bgRevers: "#FFFFFF",         
    },
    color: {
      textPrimary: "#333333",
      textSecondary: "#757575",
      textTertiary: "#BDBDBD",
      textSuccess: "#00B087",
      textDanger: "#640d14",
      textWarning: "#000000",
      textInfo: "#2196F3",
      textWhite: "#FFFFFF",
      textGhostWhite: "#F8F8FF",
      textLightGray: "#F5F5F5",
      textRevers: "#FFFFFF",
      textBlueWhite: "#2D667F",
    },
    borderColor: {
      textPrimary: "#333333",
      textSecondary: "#757575",
      textTertiary: "#BDBDBD",
      textSuccess: "#00B087",
      textDanger: "#D82F42",
      textWarning: "#000000",
      textInfo: "#2196F3",
      textWhite: "#FFFFFF",
      textGhostWhite: "#F8F8FF",
      textLightGray: "#F5F5F5",
      textRevers: "#FFFFFF",
      textBlueWhite: "#2D667F",
    },
    notificationColor: {
      create: "rgba(0, 255, 0, 0.05)",
      edit: "rgba(255, 255, 0, 0.1)",
      delete: "rgba(255, 0, 0, 0.08)",
    },
    fontSize: {
      h1: 35,
      h2: 27,
      h3: 20,
      h4: 15,
      h5: 12,
      h6: 10,
    },
  },
  dark: {
    fontFamily: {
      regular: "iranSansRegular",
      bold: "iranSansBold",
      extraBold: "iranSansExteraBold",
      light: "iranSansLight",
      medium: "iranSansMedium",
      demiBold: "iransansDemiBold",
      normal: "IRANSans",
    },
    backgroundColor: {
      bgPrimary: "#29292E",
      bgSecondary: "#17171A",
      bgTertiary: "#1f1f24",
      bgTertiaryTrans: "#29292ee6",
      bgSuccess: "#08645C",
      bgDanger: "#CC3F48",
      bgWarning: "#E09304",
      bgInfo: "#0784F2",
      bgRevers: "#000000",
      bgGray: "#AEAEAE",
      bgForm: "#17171A",
    },
    color: {
      textPrimary: "#ffffff",
      textSecondary: "#C0C0C0",
      textTertiary: "#A9A9A9",
      textSuccess: "#00B087",
      textDanger: "#f49cbb",
      textWarning: "#FFF3CD",
      textInfo: "#E0F7FA",
      textRevers: "#000000",
      textBlueWhite: "#ffffff",
    },
    borderColor: {
      textPrimary: "#333333",
      textSecondary: "#757575",
      textTertiary: "#BDBDBD",
      textSuccess: "#00B087",
      textDanger: "#D82F42",
      textWarning: "#000000",
      textInfo: "#2196F3",
      textWhite: "#FFFFFF",
      textGhostWhite: "#F8F8FF",
      textLightGray: "#F5F5F5",
      textRevers: "#FFFFFF",
      textBlueWhite: "#2D667F",
    },
    notificationColor: {
      create: "rgba(0, 255, 0, 0.05)",
      edit: "rgba(254, 255, 0, 0.2)",
      delete: "rgba(250, 0, 0, 0.05)",
    },
    fontSize: {
      h1: 35,
      h2: 27,
      h3: 20,
      h4: 15,
      h5: 12,
      h6: 10,
    },
  },
};

export default theme;
